import { render, staticRenderFns } from "./footer_bar.vue?vue&type=template&id=76b7142f&scoped=true&"
import script from "./footer_bar.vue?vue&type=script&lang=js&"
export * from "./footer_bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7142f",
  null
  
)

export default component.exports